import {
  isMobile,
  getAdsCode,
  getUrlkey,
  showFirstWithdrawDialog,
  showPreviewRechargeReward,
  showRedeemTimeDialog,
  showChargeWheel,
  goJoinEvent,
} from "@/lobby_common/utils/utils";
import grandPrizeTips from "@/lobby_common/utils/grandPrizeTips.js";
import { setLocalStorage, getLocalStorage } from "@/lobby_common/utils/auth.js";
import Store from "@/lobby_common/store/index";
import { getNoticeTemplateV2 } from "@/lobby_common/api/basic_gen.js";
import { getNewUserHelpInfo } from "@/lobby_common/api/activity_gen.js";
import { Message } from "element-ui";
// import { title } from "process";
let vm = null;
let windowDataObj = {}; // 弹窗数据
let windowData = []; // 弹窗列表数据
let windowCur = 0; // 当前的弹窗序列
let windowMax = 0; // 弹窗的总个数
let windowConfig = false; // 是否正在执行弹窗循环
const needLoginArr = ["rewardClaim"]; // 需要登录才能弹出
export function sendPopThis(_this) {
  vm = _this;
}

// 弹出设置 dialogSetting
// 每次刷新 1
// 每日弹出 2
// 不弹出   3
// 弹窗类型 dialogType
// 文本弹窗 DIALOG_CONTENT_TYPE_TEXT
// 图片弹窗 DIALOG_CONTENT_TYPE_IMAGE
// 功能弹窗 DIALOG_CONTENT_TYPE_FUNCTION
// 功能弹窗子类型 funcChildType
// 品宣     DIALOG_CONTENT_FUNC_CHILD_TYPE_BRAND_PROMOTION
// 每日签到 DIALOG_CONTENT_FUNC_CHILD_TYPE_DAILY_SIGN
// 现金红包 DIALOG_CONTENT_FUNC_CHILD_TYPE_CASH_RED_PACKAGE
// 首充礼包 DIALOG_CONTENT_FUNC_CHILD_TYPE_FIRST_RECHARGE
// 每日礼包 DIALOG_CONTENT_FUNC_CHILD_TYPE_DAILY_GIFT
// 任务中心 DIALOG_CONTENT_FUNC_CHILD_TYPE_TASK_CENTER
// 签到 DIALOG_CONTENT_FUNC_CHILD_TYPE_SIGN
// 返利宝 DIALOG_CONTENT_FUNC_CHILD_TYPE_INTEREST_TREASURE
// 登录 DIALOG_CONTENT_FUNC_CHILD_TYPE_LOGIN
// 注册 DIALOG_CONTENT_FUNC_CHILD_TYPE_REGISTER
// 定时红包图片样式  DIALOG_CONTENT_FUNC_CHILD_TYPE_TIME_REDPKG_PIC_STYLE

// 弹窗对应的值
const winViews = {
  // 公告弹窗
  DIALOG_CONTENT_TYPE_TEXT: {
    1: {
      name: "平台公告",
      views: "announcementModal",
    },
  },
  // 活动弹窗
  DIALOG_CONTENT_TYPE_IMAGE: {
    1: {
      name: "图片链接",
      views: "activityModal",
    },
  },
  // 功能弹窗
  DIALOG_CONTENT_TYPE_FUNCTION: {
    DIALOG_CONTENT_FUNC_CHILD_TYPE_BRAND_PROMOTION: {
      name: "品宣",
      views: "",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_DAILY_SIGN: {
      name: "每日签到",
      views: "",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_CASH_RED_PACKAGE: {
      name: "现金红包",
      // views: "cashEnvelope",  // 取消现金红包
      views: "",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_FIRST_RECHARGE: {
      name: "首充礼包",
      views: "everyDayGift",
      data: {
        title: "",
        width: "1024px",
        data: {
          type: 16,
        },
      },
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_DAILY_GIFT: {
      name: "每日礼包",
      views: "everyDayGift",
      data: {
        title: "",
        width: "1024px",
        data: {
          type: 17,
        },
      },
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_TURNTABLE: {
      name: "转盘活动",
      views: "turntable",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_NEW_USER_HELP_DRAW: {
      name: "拉新助力",
      views: "pullNew",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_TASK_CENTER: {
      name: "任务",
      views: "newTask",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_CODE_RANK: {
      name: "打码排行榜",
      views: "rankList",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_ACTIVITY_CENTER: {
      name: "活动中心",
      views: "activityPage",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_BIND_ACCOUNT: {
      name: "绑定账号",
      views: "",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_JOIN_ROOM: {
      name: "加入房间",
      views: "",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_MESSAGE_CENTER: {
      name: "消息中心",
      views: "notice",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_SERVICE: {
      name: "联系客服",
      views: "kehu",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_SIGN: {
      name: "签到",
      views: "signGift",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_INTEREST_TREASURE: {
      name: "返利宝",
      views: "interestTreasure",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_LOGIN: {
      name: "登录",
      views: "login",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_REGISTER: {
      name: "注册",
      views: "register",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_VIP_TURNTABLE: {
      name: "VIP集字转盘",
      views: "turntableVip",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_RECHARGE_GIFT: {
      name: "充值礼包",
      views: "chargeEnvelope",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_HOT_GAME_GIFT: {
      name: "热门游戏礼包",
      views: "hotChargeEnvelope",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_REWARD_LIST_POPUP: {
      name: "奖励列表弹窗",
      views: "freeAmount",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_REWARD_CLAIM: {
      name: "奖励领取",
      views: "rewardClaim",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_HOT_GAME: {
      name: "热门游戏",
      views: "hotNew",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_WITHDRAW_GUIDE: {
      name: "提现引导",
      views: "withdrawGuide",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_FIRST_CHARGE_RECHARGE: {
      name: "首充 / 复充",
      views: "firstChargeRecharge",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_BIG_PRIZE_POPUP: {
      name: "大奖弹窗",
      views: "bigPrizePopup",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_TIMED_REDPACKET_GUIDE: {
      name: "定时红包引导",
      views: "timedRedpacketGuide",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_RECHARGE_WHEEL: {
      name: "充值转盘",
      views: "rechargeWheel",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_INDEPENDENT_TASK: {
      name: "独立任务",
      views: "independentTask",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_BANKRUPTCY_POPUP: {
      name: "破产弹窗",
      views: "bankruptcyPopup",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_WEEK_MONTH_CARD: {
      name: "周月卡",
      views: "weekMonthCard",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_EMAIL_GUIDE: {
      name: "邮箱引导",
      views: "emailGuide",
    },
    DIALOG_CONTENT_FUNC_CHILD_TYPE_TIME_REDPKG_PIC_STYLE: {
      name: "定时红包",
      views: "redeemTime",
    },
    // ... 充值解锁提现
    DIALOG_CONTENT_FUNC_CHILD_TYPE_RECHARGE_UNLOCK_FREE_WITHDRAW: {
      name: "充值解锁免费提现",
      views: "RechargeToUnlock",
    },
  },
};

const popConfig = {
  // 初始化数据
  async initWinConfig(position = 1, isLoginAfter = false) {
    // if(Store.state.isSkipWinConfig) { // 忽略弹窗循环
    //   Store.commit('setSkipWinConfig', false)
    //   return false
    // }
    // 有其他弹窗时返回
    const dialogs = document.querySelectorAll(
      '.el-dialog__wrapper:not([style*="display: none"])'
    );
    if (dialogs.length && position !== 9) {
      return false;
    }
    // 请求位置
    const positionObj = {
      1: "DIALOG_POSITION_NOTICE", // 公告
      2: "DIALOG_POSITION_EXIT_GAME", // 游戏返回大厅
      3: "DIALOG_POSITION_SWITCH_TAB", // 切换TAB(待定)
      4: "DIALOG_POSITION_BACK_TO_LOBBY", // 其他页面返回大厅
      5: "DIALOG_POSITION_IDLE_LOBBY", // 静止大厅
      6: "DIALOG_POSITION_GAME_BANKRUPT", // 游戏破产
      7: "DIALOG_POSITION_GAME_BALANCE_NOT_ENOUGH", // 游戏下注余额不足
      8: "DIALOG_POSITION_GAME_SETTLEMENT", // 游戏下注结算后（待定）
      9: "DIALOG_POSITION_WITHDRAW_APPLY", // 申请提现
      10: "DIALOG_POSITION_RECHARGE_CASHIER", // 入款收银台
    };
    // return false // 调试阻断
    // login_status  1 已登陆   2未登录
    // 其他页面不进行弹窗循环
    // if (vm.$route.path !== "/home" && vm.$route.path !== "/") {
    //   return false;
    // }
    const urlParams = getUrlkey() || {};
    const creatRoomParams =
      urlParams || JSON.parse(localStorage.setItem("creatRoomParams")) || {};
    console.log(creatRoomParams, "creatRoomParams");
    if (
      creatRoomParams?.game_id &&
      (creatRoomParams?.room_id || creatRoomParams?.team_id)
    ) {
      return false;
    }
    if (isLoginAfter && window.registerRewardEnable) {
      // console.log("======isLoginAfter && window.registerRewardEnable======");
      window.registerRewardEnable = false;
      return false;
    }
    const userData = Store.getters.user || {};
    const agentAccount =
      Store?.getters?.getPacketConfig?.packetInfo?.baseInfo?.agentAccount || "";
    const adsCode = getAdsCode();
    const invite_code = getLocalStorage("inviteCode") || "";
    const isNewDevice = localStorage.getItem("isNewDevice");
    const isLogin = Store?.getters?.login;
    const params = {
      agentAccount: userData?.agentAccount || agentAccount,
      parentSid: userData?.parentSid || "0",
      haveBigMediaTag: !!adsCode.adsCode, // 是否有大媒体标签
      inviteCode: invite_code,
      newDevice: !isLogin && isNewDevice && isNewDevice === "true",
      position: positionObj[position],
    };
    // 开始弹窗
    const res = await getNoticeTemplateV2(params);
    const code = res?.code ?? -1; // 确保有值
    const data = res?.data ?? {};
    if (code === 0) {
      windowData = data.list || [];
      windowDataObj = data || {};
      vm.$store.commit("setDisplayPromoteUrl", data?.displayPromoteUrl);
    } else {
      return false;
    }

    // 弹窗数据处理
    windowData = popConfig.updataWindowData();

    // console.log(windowData, '---筛选组装后的弹窗循环数组数据----')

    // 配置参数  然后开始执行弹窗控制
    if (windowData && windowData.length === 0) return false;

    windowData.map((v) => {
      if (winViews[v.dialogType]) {
        const filed =
          v.dialogType === "DIALOG_CONTENT_TYPE_FUNCTION" ? v.funcChildType : 1; // 根据是否为功能弹窗取不同的字段
        v.views = winViews[v.dialogType][filed]
          ? winViews[v.dialogType][filed].views
          : undefined;
        v.data = winViews[v.dialogType][filed]
          ? winViews[v.dialogType][filed].data
          : undefined;
      } else {
        v.views = undefined;
      }
    });
    windowCur = 0;
    windowMax = windowData.length;
    windowConfig = true;
    popConfig.goCurWin();
  },

  // 弹窗数据处理
  updataWindowData() {
    let arr = [...windowData];

    // 缓存用户子公告弹出次数、间隔数据
    if (Store.getters.taken && arr.length > 0) {
      arr = popConfig.getStorageData();
    }

    // 筛除不弹出
    arr =
      arr.filter((v) => {
        return v.dialogSetting !== 3;
      }) || [];
    if (arr.length === 0) {
      return [];
    }

    // 弹窗文本、图片、功能排序
    const sorts = [];
    arr.forEach((item) => {
      if (!sorts.includes(item.dialogType)) {
        sorts.push(item.dialogType);
      }
    });
    // 提取公告弹窗 组成一个新对象 放在数组第一个
    const txtWinArr =
      arr.filter((v) => {
        return v.dialogType === "DIALOG_CONTENT_TYPE_TEXT";
      }) || []; // 文本（公告）弹窗
    const imgWinArr =
      arr.filter((v) => {
        return v.dialogType === "DIALOG_CONTENT_TYPE_IMAGE";
      }) || []; // 图片（活动）弹窗
    const otherWinArr =
      arr.filter((v) => {
        return v.dialogType === "DIALOG_CONTENT_TYPE_FUNCTION";
      }) || []; // 功能弹窗
    const winArrs = [];
    sorts.forEach((item) => {
      if (item === "DIALOG_CONTENT_TYPE_TEXT") {
        const obj = { ...txtWinArr[0], bulletinList: [...txtWinArr] };
        winArrs.push(obj);
      } else if (item === "DIALOG_CONTENT_TYPE_IMAGE") {
        const obj1 = { ...imgWinArr[0], bulletinList: [...imgWinArr] };
        winArrs.push(obj1);
      } else if (item === "DIALOG_CONTENT_TYPE_FUNCTION") {
        winArrs.push(...otherWinArr);
      }
    });
    return winArrs;
    // if (imgWinArr.length > 0) {
    //   const obj = { ...imgWinArr[0], bulletinList: [...imgWinArr] };
    //   otherWinArr.unshift(obj);
    // }
    // if (txtWinArr.length > 0) {
    //   const obj = { ...txtWinArr[0], bulletinList: [...txtWinArr] };
    //   otherWinArr.unshift(obj);
    // }
    // return otherWinArr;
  },
  getStorageData() {
    const rawSid = Store.getters.user.sid;
    const userSid = String(rawSid);
    const day = new Date().Format("yyyy-MM-dd");
    const obj = { ...windowDataObj };
    const ruleSid = String(obj.popupRuleSid);
    const arr = obj.list || [];

    // 读取本地缓存
    const noticeObj = getLocalStorage("noticeObj") || {};
    const userData = noticeObj[userSid] || {};

    //  删除不是当天的日期
    Object.keys(userData).forEach((d) => {
      if (d !== day) delete userData[d];
    });

    //  确保当天结构存在
    if (!userData[day]) userData[day] = {};
    if (!userData[day][ruleSid]) userData[day][ruleSid] = {};

    //  遍历当前通知，处理 apiTimes 累加
    arr.forEach((v) => {
      if (v.dialogSetting === 2) {
        // 每日弹出
        const sid = String(v.sid);
        const oldItem = userData[day][ruleSid][sid];
        const num = v.times * v.interval;
        const apiTimes = oldItem
          ? oldItem.apiTimes > num
            ? oldItem.apiTimes
            : oldItem.apiTimes + 1
          : 1;
        userData[day][ruleSid][sid] = { apiTimes };

        // 控制隐藏逻辑
        if (v.interval <= 1) {
          if (apiTimes > num) v.isHide = true;
        } else {
          if (apiTimes > num || apiTimes % v.interval !== 1) v.isHide = true;
        }
      }
    });

    //  最多保留 3 个用户数据
    const keys = Object.keys(noticeObj);
    if (!noticeObj[userSid] && keys.length >= 3) {
      const firstKey = keys[0];
      delete noticeObj[firstKey];
    }

    //  更新缓存对象
    noticeObj[userSid] = userData;
    setLocalStorage("noticeObj", noticeObj);
    const visibleArr = arr.filter((v) => !v.isHide);
    return visibleArr;
  },
  // 执行当前的弹窗
  goCurWin() {
    if (windowCur >= windowMax) {
      // 关闭弹窗逻辑
      popConfig.endWinConfig();
      return false;
    }
    if (popConfig.isShow(windowData[windowCur])) {
      console.log("显示弹窗，弹窗对象:", windowData[windowCur], windowCur);
      const it = windowData[windowCur] || {};
      // 公告弹窗打点(功能弹窗不打点)
      if (it.dialogType !== "DIALOG_CONTENT_TYPE_FUNCTION") {
        vm.$eventPost("tpgn_notice_pop", {
          pop_type: it.dialogType,
          function_type: it.funcChildType,
          jump_value: it.jump || {},
          name: it.name || "",
          ruleName: it.ruleName || "",
          ruleSid: it.ruleSid || "",
        });
      }
      popConfig.showWin(windowData[windowCur]);
    } else {
      // 当前的不弹出 继续弹下一个
      console.log("不显示弹窗，弹窗对象:", windowData[windowCur], windowCur);
      popConfig.winConfigNext();
    }
  },

  // 判断当前的弹窗是否弹出
  isShow(obj = {}) {
    if (windowConfig !== true) {
      // 循环弹窗关闭
      return false;
    } else {
      // 找不到对应的弹窗
      if (!obj.views) return false;

      return true;
      // 判断弹窗对象obj 是否显示 每日显示  后台处理
      // if(obj.popup_status === 0) return false   // 不显示
      // if(obj.popup_status === 1) return true    // 每次显示
      // if(obj.popup_status === 2) {  // 每日显示
      //   const win_show_time = localStorage.getItem(obj.views + '_show_time')
      //   const day = new Date().Format("yyyy-MM-dd")
      //   if(win_show_time === String(day)) {
      //     // 今日已经显示
      //     return false
      //   } else {
      //     // 今日未显示
      //     localStorage.setItem(obj.views + '_show_time', day)
      //     return true
      //   }
      // }
    }
  },

  // 打开当前弹窗
  async showWin(obj = {}) {
    if (!obj) return false;
    const position = "Announcement";
    if (obj.views === "RechargeToUnlock") {
      const isMobile = vm.$store?.getters?.getIsMobile;
      if (Store.getters.taken) {
        vm.$isPopShow({
          show: true,
          views: "rechargeToUnlock", // 弹出活动界面
          data: {
            hideTitle: true,
            backBtn: !!isMobile,
          },
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "announcementModal") {
      // all文本弹窗
      winFun.getNoticeList(obj);
    } else if (obj.views === "activityModal") {
      // all图片弹窗
      winFun.showActivityModal(obj);
    } else if (obj.views === "pullNew") {
      // 拼多多拉新转盘助力活动
      winFun.showpullNewpower({ position });
    } else if (obj.views === "turntable") {
      // 转盘
      if (Store.getters.taken) {
        vm.$isPopShow({
          show: true,
          views: "turntable",
          data: {
            title: "",
            width: "450px",
            position,
          },
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "rankList") {
      // 打码排行榜
      vm.$isPopShow({
        show: true,
        views: "RankMode2",
        fullscreen: false,
        data: {
          backBtn: true,
          title: vm.$t("Datalang.Invite_BTM_rankings"),
          width: "1000px",
          position,
        },
      });
    } else if (obj.views === "signGift") {
      // 签到
      if (Store.getters.taken) {
        vm.$isPopShow({
          show: true,
          views: "signGift",
          data: {
            title: "",
            backBtn: true,
            width: "1000px",
            position,
          },
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "interestTreasure") {
      // 返利宝
      if (Store.getters.taken) {
        vm.$isPopShow({
          show: true,
          views: "interestTreasure",
          data: {
            backBtn: true,
            title: vm.$t("Datalang.home_interest"),
            width: "1000px",
            position,
          },
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "newTask") {
      // 任务中心
      if (Store.getters.taken) {
        vm.$isPopShow({
          show: true,
          views: "newTask",
          data: {
            hideTitle: true,
            backBtn: !!isMobile,
            position,
          },
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "everyDayGift") {
      // 新手红包和每日红包
      winFun.showEveryDayGift(obj);
    } else if (obj.views === "activityPage") {
      // 活动中心
      const path = isMobile ? "/hEvents?tab=2" : "/events?tab=2";
      vm.$router.push(path);
    } else if (obj.views === "notice") {
      // 消息中心
      const path = isMobile ? "/user/hNoticeCenter" : "/user/notice";
      vm.$router.push(path);
    } else if (obj.views === "kehu") {
      if (Store.getters.taken) {
        vm.$Bus.$emit("goKehu");
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "login") {
      if (!Store.getters.taken) {
        vm.$nextTick(() => {
          vm.$Bus.$emit("showLogin", { tab: "Login" });
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "register") {
      if (!Store.getters.taken) {
        vm.$nextTick(() => {
          vm.$Bus.$emit("showLogin", { tab: "Register" });
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (
      obj.views === "chargeEnvelope" ||
      obj.views === "hotChargeEnvelope"
    ) {
      // 充值礼包
      if (Store.getters.taken) {
        vm.$isPopShow({
          show: true,
          views: "chargeEnvelope",
          fullscreen: false,
          data: {
            sid: obj.rechargeGiftSid,
            SubGiftpack: "Announcement",
            title: "",
            width: "360px",
          },
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "withdrawGuide") {
      // 提现引导
      if (Store.getters.taken) {
        showFirstWithdrawDialog("return", position);
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "firstChargeRecharge") {
      // 首充 / 复充
      if (Store.getters.taken) {
        showPreviewRechargeReward("Recharge", position);
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "bigPrizePopup") {
      // 大奖弹窗
      grandPrizeTips.initGrandPrizeList(position);
    } else if (obj.views === "timedRedpacketGuide") {
      // 定时红包引导
      if (Store.getters.taken) {
        showRedeemTimeDialog(position);
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "rechargeWheel") {
      // 充值转盘
      if (Store.getters.taken) {
        showChargeWheel(position);
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "independentTask") {
      // 独立任务
      if (Store.getters.taken) {
        const jump = {
          type: "JUMP_TYPE_TASK_CENTER",
          taskJump: obj.taskSid,
          position,
        };
        goJoinEvent(jump);
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "bankruptcyPopup") {
      // 破产弹窗
      if (Store.getters.taken) {
        showPreviewRechargeReward("Bankruptcy", position);
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "weekMonthCard") {
      // 周月卡
      if (Store.getters.taken) {
        vm.$isPopShow({
          show: true,
          views: "weekMonthCard",
          data: {
            title: "",
            width: "1000px",
            position,
          },
        });
      } else {
        popConfig.winConfigNext();
      }
    } else if (obj.views === "redeemTime") {
      if (Store.getters.taken) {
        vm.$isPopShow({
          show: true,
          views: "redeemTime",
          fullscreen: false,
          data: {
            title: vm.$t("Datalang.Scheduled_Red_Packets"),
          },
        });
      } else {
        popConfig.winConfigNext();
      }
    } else {
      // 公共弹出弹窗方法
      if (needLoginArr.includes(obj.views) && !Store.getters.taken) {
        popConfig.winConfigNext();
      } else {
        vm.$isPopShow({
          show: true,
          views: obj.views,
          data: {
            title: obj.title,
            position,
          },
        });
      }
    }
  },

  // 结束弹窗循环
  async endWinConfig() {
    windowCur = 0;
    windowConfig = false;
  },

  // 参数错误  弹窗结束   例如弹窗需要登录后弹， 却配置在了未登录
  async winConfigError() {
    windowCur = 0;
    windowConfig = false;
    Message({
      message: vm.$t("msgcode.10001") || "Error",
      type: "error",
      showClose: true,
    });
  },

  // 下一个弹窗  例如现金红包过期， 首充复充不符合条件 或者手动点击下一个弹窗等
  async winConfigNext() {
    if (windowConfig) {
      windowCur++;
      popConfig.goCurWin();
    }
  },
};

// 打开现金红包
const winFun = {
  async showpullNewpower(obj) {
    const { data, code } = await getNewUserHelpInfo({});
    if (code === 0 && data) {
      // console.log("data", data);
      let status = 1;
      if (data.startTime && data.startTime !== "0") {
        // 活动参与中
        status = 2; // 展示恭喜您...
      } else {
        // data.startTime === "0"
        if (data.completeStatus === 0) {
          // 未完成
          if (data.currentAmount && data.currentAmount !== "0") {
            // 72小时内未完成
            status = 3;
          } else {
            // 未参与活动
            status = 1;
          }
        } else if (data.completeStatus === 1) {
          // 完成活动了，但是72小时内未领取
          status = 4;
        } else {
          // data.completeStatus === 2 已领取
          status = 1;
        }
      }
      vm.$Bus.$emit("showPullNewModal", {
        pullNewInfo: {
          ...data,
          isStart: status,
          isPop: true,
          position: obj.position,
        },
        show: true,
      });
      // popConfig.endWinConfig();
    } else {
      popConfig.winConfigNext();
    }
  },
  async showEveryDayGift(obj) {
    if (!Store.getters.taken) {
      popConfig.winConfigError();
      return false;
    }
    // const chargeRes = await getChargeData();
    // const daily = chargeRes.data?.config?.daily || [];
    // const onlyOne = chargeRes.data?.config?.only_one || [];
    // const arr1 = daily[0]?.extra_field ? JSON.parse(daily[0]?.extra_field) : [];
    // const arr2 = onlyOne[0]?.extra_field
    //   ? JSON.parse(onlyOne[0]?.extra_field)
    //   : [];
    // const dailyShow = arr1?.some((item) => item.can_recharge > 0); // 每日52
    // const onlyOneShow = arr2?.some((item) => item.can_recharge > 0); // 首充51
    // // 每日
    // if (dailyShow && obj.data.data.type === 17) {
    //   obj.data.title = vm.$t("Datalang.Event_TITLE_dailypack");
    //   vm.$isPopShow({
    //     show: true,
    //     views: obj.views,
    //     data: obj.data,
    //   });
    // } else if (onlyOneShow && obj.data.data.type === 16) {
    //   // 首充
    //   obj.data.title = vm.$t("Datalang.Event_TITLE_fristrecharge");
    //   vm.$isPopShow({
    //     show: true,
    //     views: obj.views,
    //     data: obj.data,
    //   });
    // } else {
    //   // 继续走下一个弹窗
    //   popConfig.winConfigNext();
    // }

    // 每日礼包没做，暂时注释上面代码，走下一个
    // 继续走下一个弹窗
    popConfig.winConfigNext();
  },
  // 获取活动公告轮播
  async getNoticeList(obj) {
    const EventType = Store.getters.getShowEvent;
    // console.log(EventType, "EventType=====EventType");
    let showEventModal = false;
    const contentList = obj.bulletinList || [];
    const isShowEvents = localStorage.getItem("isShowEvents"); // 今日不在显示
    const evryDayEvent = localStorage.getItem("evryDayEvent"); // 每天弹出
    const evryLoginEvent = localStorage.getItem("evryLoginEvent"); // 每
    const today = new Date().Format("yyyy-MM-dd");
    const _list = contentList;
    // if (evryLoginEvent && evryDayEvent === today) {
    //   _list = [];
    // }

    // // 如果今天已经登录过 则把登录弹出的过滤掉
    // if (evryLoginEvent) {
    //   _list =
    //     _list?.filter((item) => {
    //       if (item.popup_status !== 1) {
    //         return item;
    //       }
    //     }) || [];
    // }
    // if (evryDayEvent === today) {
    //   _list =
    //     _list?.filter((item) => {
    //       if (item.popup_status !== 2) {
    //         return item;
    //       }
    //     }) || [];
    // }

    // if (!_list.length) {
    //   showEventModal = false;
    //   // 不弹出下一步
    //   popConfig.winConfigNext();
    //   return;
    // }

    if (isShowEvents === today) {
      showEventModal = false;
      popConfig.winConfigNext();
    } else {
      showEventModal = true;
      setTimeout(() => {
        vm.$Bus.$emit("showAnnouncementModal", {
          list: _list,
          show: showEventModal,
        });
      }, 500);
    }
  },
  async showActivityModal(obj) {
    const _list = obj.bulletinList || [];
    if (_list && _list.length) {
      vm.$Bus.$emit("showActivityModal", { list: _list, show: true });
    } else {
      // 继续走下一个弹窗
      popConfig.winConfigNext();
    }
  },
};

export default popConfig;
